// Situatie 1 : load pagina : https://url/#idvanelement
// Situatie 2 : <a href="#idvanelement" class="anchor">..</a>

function scrollToHash(hash, e) {
  if(e) e.preventDefault();
  const elem = hash ? document.querySelector(hash) : false;
  if(elem) {
    if(e) e.preventDefault();
    if( window.gsap ) {
      gsap.to(window, {scrollTo: elem});
    } else {
      elem.scrollIntoView({ behavior: 'smooth' }); // vanilla fallback
    }
  }
}